<template>
  <div class="list-box">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.name"
          style="width: 200px"
          placeholder="--关键字--"
          clearable
          @clear="
            delete state.params.name;
            onLoad();
          "
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
      <el-button
        type="primary"
        :icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
        >添加</el-button
      >
    </ul>
    <ul class="list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="50"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态" sortable="collected_status">
          <template #default="{ row }">
            <text v-if="row.collected_status == 0">待认领</text>
            <text v-else-if="row.collected_status == 1" style="color: #1e90ff"
              >认领中</text
            >
            <text v-else-if="row.collected_status == 2" style="color: #080"
              >已认领</text
            >
            <text v-else>-</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          sortable="name"
          label="名称"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
          min-width="140"
        />
        <el-table-column
          prop="account"
          label="银行账号"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="opening_bank"
          label="开户行"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="received_amount"
          label="到账总额"
          :formatter="$tab_PriceFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="collected_amount"
          label="已认领金额"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="uncollected_amount"
          label="未认领金额"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          prop="service_fee"
          label="手续费总额"
          :formatter="$tab_TextFormat"
          show-overflow-tooltip
        />
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
            >
              撤回
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        @onLoad="
          (pageIndex) => {
            state.params.page = pageIndex;
            onLoad();
          }
        "
      />
    </ul>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showInfo"
      :title="(state.selectId ? '修改' : '添加') + '到账公示'"
      @close="state.showInfo = false"
    >
      <c_BankReceivedInfo
        @close="
          state.showInfo = false;
          onLoad();
        "
        :id="state.selectId"
      ></c_BankReceivedInfo>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { bankreceived_collects } from "@/http/api";

class InitFormData {
  params = {
    limit: 0,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      bankreceived_collects(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.Order = column.sortable;
        state.params.Asc = column.order === "ascending";
      } else {
        const params = new InitFormData().params;
        state.params.Order = params.Order;
        state.params.Asc = params.Asc;
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style scoped></style>
